import * as React from "react";
import { Typography } from "@mui/material";

// Credit line laid over the bottom-right corner of a picture. The parent
// needs position: relative.
export default function PhotoCredit(props: { credit: string | null | undefined }) {
  if (!props.credit) return null;
  return (
    <Typography
      sx={{
        position: "absolute",
        right: 6,
        bottom: 6,
        px: 0.75,
        py: 0.25,
        borderRadius: 1,
        bgcolor: "rgba(9,5,11,0.7)",
        color: "rgba(226,232,240,0.85)",
        fontSize: 10,
        lineHeight: 1.4,
        maxWidth: "calc(100% - 12px)",
      }}
    >
      {props.credit}
    </Typography>
  );
}
